import Checkbox from './src'

Checkbox.install = Vue => {
  Vue.component(Checkbox.name, Checkbox)
}

export default Checkbox
